import { useState } from 'react';

import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { LoadingButton } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';

interface OrganizationDeleteDialogProps {
  organization_ids: string[];
  deleteOrganizations: (organization_ids: string[]) => Promise<void>;
  open: boolean;
  handleClose: () => void;
}

function OrganizationDeleteDialog({
  organization_ids,
  deleteOrganizations,
  open,
  handleClose,
}: OrganizationDeleteDialogProps): React.JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (): Promise<void> => {
    try {
      setLoading(true);
      await deleteOrganizations(organization_ids);
      handleClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog onClose={() => handleClose()} open={open}>
      <DialogTitle>
        <Grid container direction='row' alignItems='center'>
          <Grid size={11}>Permanently Delete Organization</Grid>
          <Grid size={1} sx={{ maxWidth: '25px' }}>
            <IconButton aria-label='close' onClick={() => handleClose()}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Box
          padding='10px'
          sx={{
            display: 'flex',
            maxWidth: 800,
          }}
        >
          <Alert severity='error'>
            This action is permanent and cannot be undone. Only delete an
            organization if the customer contract has expired and you are certain
            its associated assets and configuration should be removed. Are you
            sure you want to permanently delete this organization?
          </Alert>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
          <Button
            color='inherit'
            onClick={handleClose}
            sx={{ mr: 1, flex: '1 1 auto' }}
          >
            Cancel
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          <LoadingButton
            loading={loading}
            variant='contained'
            color='primary'
            onClick={handleSubmit}
            disabled={organization_ids.length !== 1}
          >
            Delete
          </LoadingButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

export default OrganizationDeleteDialog;

